import React from 'react';
import ReactDOM from 'react-dom/client';
import DebtClockEmbed from './DebtClockEmbed';
import ErrorBoundary from './components/ErrorBoundary';

const embedRoots = document.querySelectorAll('[data-debt-clock-root]');

embedRoots.forEach((rootElement) => {
  const root = ReactDOM.createRoot(rootElement);
  const { province, language, variant } = rootElement.dataset;

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <DebtClockEmbed
          province={province}
          language={language}
          variant={variant}
        />
      </ErrorBoundary>
    </React.StrictMode>
  );
});
